import { NotificationServiceBase } from '@avano/avano-components/avano-notifications/notification-service.base';
import { Observable } from 'rxjs';
import { MessageSeverity, Notification, NotificationType } from '@avano/avano-components/avano-notifications/+state/notifications/notifications.models';
import { NotificationAddDto, NotificationControllerService } from '@scip/api';
import { map, mapTo } from 'rxjs/operators';
import { NotificationDto } from '@scip/api';
import { Injectable } from '@angular/core';
import * as dayjs from 'dayjs';
import { DownloadService } from './download.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService implements NotificationServiceBase {
  constructor(private service: NotificationControllerService, private downloadService: DownloadService) {}

  markAsRead(notificationId: number): Observable<void> {
    return this.service.markNotificationRead(notificationId).pipe(mapTo(null));
  }

  deleteOne(notificationId: number): Observable<void> {
    return this.service.deleteNotification(notificationId);
  }

  loadNotifications(): Observable<Notification[]> {
    return this.service
      .getNotificationsForTheCurrentUser()
      .pipe(map((notifications: NotificationDto[]) => notifications.map((notification: NotificationDto) => this.mapToNotification(notification))));
  }

  addNotification(notification: Notification): Observable<Notification> {
    return this.service
      .addNotification(notification as unknown as NotificationAddDto)
      .pipe(map((notificationDto) => notificationDto as unknown as Notification));
  }

  downloadReport(reportId: number, filename: string): Observable<void> {
    return this.downloadService.downloadReport(reportId, filename);
  }

  private mapToNotification(notification: NotificationDto): Notification {
    return {
      id: notification.id,
      date: dayjs(notification.createdAt).toDate(),
      type: notification.type === 'DOWNLOAD' ? NotificationType.Download : NotificationType.Message,
      severity: MessageSeverity[notification.severity],
      detail: notification.detail,
      summary: notification.summary,
      isRead: notification.isRead,
      reportDto: notification.reportDto
    };
  }
}
